// Explicit build-time opt-in AND a local origin. Never enter a sandbox merely
// because authentication, the network, or the production API failed.
export function sandboxAllowed(flag, hostname) {
  return flag === 'true' && ['localhost', '127.0.0.1', '[::1]', '::1'].includes(hostname);
}

export function isEdenSandbox() {
  return sandboxAllowed(process.env.REACT_APP_EDEN_SANDBOX, window.location.hostname);
}
